export default __webpack_public_path__ + "static/media/instagramNoFill.ca85b196.svg";